/* iter55f88 — Chapter display-label helper.
 *
 * Single source of truth for how a chapter label should render given
 * the project-wide `chapter_titles_visible` toggle.
 *
 * Design goal — non-destructive: `chapter.title` on the row is NEVER
 * overwritten. This helper only decides what to show. Flipping the
 * toggle off then on again restores every original title with zero
 * data loss because we didn't touch the stored value.
 *
 * If the toggle is unset (legacy projects that predate the field),
 * default to `true` (show titles).
 */
export function chapterLabel(chapter, project) {
  const visible = project?.chapter_titles_visible !== false;
  const generic = `Chapter ${chapter?.number ?? '?'}`;
  if (!visible) return generic;
  const t = (chapter?.title || '').trim();
  return t || generic;
}
